import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format } from 'date-fns'
import { siteConfig } from '@/config/site'
import { isNil } from 'lodash'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatDateTime = (date: string | null) => {
  if (typeof date !== 'string' || isNaN(Date.parse(date))) return '-'
  return format(new Date(date), siteConfig.dateTimeFormat)
}

export const formatDate = (date: string | null) => {
  if (typeof date !== 'string' || isNaN(Date.parse(date))) return '-'
  return format(new Date(date), siteConfig.dateFormat)
}

export const upperCaseFirstLetter = (str: string | null | undefined) => {
  if (isNil(str)) return null
  str = str.toLowerCase()
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const calculatingPageCount = (
  aggregate: number,
  limit: number | null | undefined
) => {
  return Math.ceil(aggregate / (limit ?? siteConfig.table.limit))
}

export default function roleLabel(role: number) {
  const ROLES: { [key: number]: string } = {
    6: 'Enterprise Member',
    7: 'Enterprise Admin',
  }

  return ROLES[role]
}

export function toTitleCase(text: string): string {
  if (!text) text = 'None'
  return text
    .toLowerCase()
    .replace(/(^|\s)\w/g, (letter) => letter.toUpperCase())
}
